(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('TicketrealtimeDeleteController',TicketrealtimeDeleteController);

    TicketrealtimeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Ticketrealtime'];

    function TicketrealtimeDeleteController($uibModalInstance, entity, Ticketrealtime) {
        var vm = this;

        vm.ticketrealtime = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Ticketrealtime.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
